import styled from 'styled-components';

export const LoaderItem = styled.div`
  position: relative;
  height: 32px;
  min-width: 64px;
`;

export const DisabledItem = styled.div`
  color: light-dark(#bbb, var(--moon-550));
  padding: 8px 16px 8px 16px;
  font-size: 14px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
`;
